import { Box, Typography } from '@mui/material';
import { FC } from 'react';
import { useLocation } from 'react-router';
import { Link } from 'react-router-dom';

import { Colors } from '@/assets';
import { PermissionRequired } from '@/features/auth';

interface ITab {
    label: string;
    isActive?: boolean;
    path?: string;
    permissionRequired?: PermissionRequired | null;
    onClick?: () => void;
}

interface IProps {
    tabs: ITab[];
}
export const MenuSquare: FC<IProps> = ({ tabs }) => {
    const { pathname } = useLocation();

    return (
        <>
            <Box sx={{ display: 'flex', flexWrap: 'wrap' }}>
                {tabs.map((tab, index) => {
                    const isActive = tab.path === pathname ?? tab.isActive ?? false;
                    const isFirstTab = index === 0;
                    const isLastTab = index === tabs.length - 1;
                    return (
                        <Box
                            component={tab.path ? Link : Box}
                            to={tab.path ?? '#'}
                            key={index}
                            onClick={tab.onClick}
                            sx={{
                                border: '1px solid',
                                borderRight: isLastTab ? '1px solid' : 0,
                                borderColor: Colors.linkWater,
                                borderRadius: isFirstTab ? '0.8rem 0 0 0.8rem' : isLastTab ? '0 0.8rem 0.8rem 0' : '0',
                                px: 2,
                                py: 1.2,
                                cursor: 'pointer',
                                background: isActive ? Colors.ghostWhite : Colors.white,
                                '&:hover': {
                                    background: Colors.ghostWhite
                                },
                                '&:hover > h6': {
                                    transform: 'scale(1.05)',
                                    transition: 'all 0.2s ease-in-out'
                                }
                            }}
                        >
                            <Typography
                                variant="subtitle1"
                                sx={{
                                    color: isActive ? Colors.tangaroaBlue : Colors.cloudBurstBlue,
                                    fontWeight: 500
                                }}
                            >
                                {tab.label}
                            </Typography>
                        </Box>
                    );
                })}
            </Box>
        </>
    );
};
